import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setHomePage } from '../redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useHeroSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getHeroSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website.home_page.hero_section}`);
      console.log("🚀 ~ getHeroSectionJson ~ data:", response);
      console.log("🚀 ~ getHeroSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setHomePage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching hero section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getHeroSectionJson();
  }, [getHeroSectionJson]);

  return {
    data,
    loading,
    error,
    getHeroSectionJson,
    fetchOnMount,
    refetch: getHeroSectionJson
  };
};

export default useHeroSection;
